import React from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useNavigate } from 'react-router-dom';

interface LegalDocumentProps {
  content: string;
}

export const LegalDocument: React.FC<LegalDocumentProps> = ({ content }) => {
  const { t } = useLocale();
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', padding: '2rem' }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        padding: '2rem',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      }}>
        <div style={{ lineHeight: '1.8', color: '#374151' }}>
          <div className="prose prose-lg max-w-none">
            <ReactMarkdown
              components={{
                h1: ({ node, ...props }) => (
                  <h1
                    style={{
                      fontSize: '2.25rem',
                      fontWeight: '700',
                      marginTop: '2rem',
                      marginBottom: '1.5rem',
                      color: '#111827',
                      lineHeight: '1.2',
                    }}
                    {...props}
                  />
                ),
                h2: ({ node, ...props }) => (
                  <h2
                    style={{
                      fontSize: '1.875rem',
                      fontWeight: '600',
                      marginTop: '2.5rem',
                      marginBottom: '1rem',
                      color: '#111827',
                      lineHeight: '1.3',
                    }}
                    {...props}
                  />
                ),
                h3: ({ node, ...props }) => (
                  <h3
                    style={{
                      fontSize: '1.5rem',
                      fontWeight: '600',
                      marginTop: '2rem',
                      marginBottom: '0.75rem',
                      color: '#111827',
                      lineHeight: '1.4',
                    }}
                    {...props}
                  />
                ),
                hr: ({ node, ...props }) => (
                  <hr
                    style={{
                      marginTop: '3rem',
                      marginBottom: '3rem',
                      border: 'none',
                      borderTop: '1px solid #e5e7eb',
                    }}
                    {...props}
                  />
                ),
                p: ({ node, ...props }) => (
                  <p
                    style={{
                      marginTop: '1rem',
                      marginBottom: '1rem',
                    }}
                    {...props}
                  />
                ),
                ul: ({ node, ...props }) => (
                  <ul
                    style={{
                      marginTop: '1rem',
                      marginBottom: '1rem',
                      paddingLeft: '1.5rem',
                    }}
                    {...props}
                  />
                ),
                ol: ({ node, ...props }) => (
                  <ol
                    style={{
                      marginTop: '1rem',
                      marginBottom: '1rem',
                      paddingLeft: '1.5rem',
                    }}
                    {...props}
                  />
                ),
                li: ({ node, ...props }) => (
                  <li
                    style={{
                      marginTop: '0.5rem',
                      marginBottom: '0.5rem',
                    }}
                    {...props}
                  />
                ),
                strong: ({ node, ...props }) => (
                  <strong
                    style={{
                      fontWeight: '600',
                      color: '#111827',
                    }}
                    {...props}
                  />
                ),
                a: ({ node, ...props }) => (
                  <Link
                    to={props.href || '#'}
                    style={{
                      color: 'var(--scribane-black)',
                      textDecoration: 'underline',
                    }}
                    onClick={(e) => {
                      if (props.href?.startsWith('/')) {
                        e.preventDefault();
                        navigate(props.href);
                      }
                    }}
                  >
                    {props.children}
                  </Link>
                ),
              }}
            >
              {content}
            </ReactMarkdown>
          </div>
        </div>

        <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #e5e7eb', textAlign: 'center' }}>
          <Link
            to="/"
            style={{
              color: 'var(--scribane-black)',
              textDecoration: 'none',
              fontSize: '0.875rem',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.textDecoration = 'none';
            }}
          >
            {t('back_to_home')}
          </Link>
        </div>
      </div>
    </div>
  );
};

